import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, Fragment, useState, useCallback, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { CheckboxInputStateContext } from '../../utils/InputStateContext';
import { CheckboxIcon, } from '../CheckboxIcon';
import { sizes } from './constants';
const additionalTextStyles = css `
  display: inline-block;
`;
const labelStyles = css `
  ${theme.typeStyles.bodyBoldStyles}
  display: inline-block;
`;
const checkboxContainerStyles = css `
  ${styleUtils.borderBox}
  cursor: pointer;
  display: flex;
  flex-direction: row;
`;
const defaultProps = {
    shape: 'square',
    size: sizes.medium,
};
const Checkbox = ({ additionalText, ariaChecked, ariaDescribedBy, ariaLabel, ariaLabelledBy, checked, disabled, id, label, name, onChange, shape = defaultProps.shape, size = defaultProps.size, }) => {
    const [isHovering, setIsHovering,] = useState(false);
    const onPointerEnter = useCallback(() => {
        setIsHovering(true);
    }, []);
    const onPointerLeave = useCallback(() => {
        setIsHovering(false);
    }, []);
    const providerValue = useMemo(() => ({
        isHovering,
    }), [
        isHovering,
    ]);
    const labelId = useMemo(() => (`label-for-${id || name}`), [
        id,
        name,
    ]);
    const labelContainerStyles = useMemo(() => (css `
        ${theme.typeStyles.bodyMediumStyles}
        display: flex;
        flex-direction: column;
        margin-left: ${theme.spacing.x3};
        padding-top: calc(${theme.spacing.base} / 2);
        row-gap: ${theme.spacing.base};
        ${disabled && css `
          color: ${theme.colors.gray500};
        `}

        ${size === 'small' && css `
          ${theme.typeStyles.bodyExtraSmallStyles}
          padding-top: ${styleUtils.rem(1)};
        `}
      `), [
        disabled,
        size,
    ]);
    return (_jsx(Fragment, { children: _jsxs("label", Object.assign({ css: checkboxContainerStyles, htmlFor: id || name, id: labelId, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave }, { children: [_jsx("input", { "aria-checked": ariaChecked, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy !== null && ariaLabelledBy !== void 0 ? ariaLabelledBy : labelId, css: css `
              position: absolute;
              clip: rect(0, 0, 0, 0);
            `, defaultChecked: checked, disabled: disabled, id: id || name, name: name, onChange: onChange, type: "checkbox" }), _jsx(CheckboxInputStateContext.Provider, Object.assign({ value: providerValue }, { children: _jsx(CheckboxIcon, { checked: checked, disabled: disabled, shape: shape, size: size }) })), (label
                    || additionalText)
                    && (_jsxs("div", Object.assign({ css: labelContainerStyles }, { children: [label && (_jsx("span", Object.assign({ css: labelStyles }, { children: label }))), additionalText && (_jsx("span", Object.assign({ css: additionalTextStyles }, { children: additionalText })))] })))] })) }));
};
export { Checkbox };
